<template>
  <v-container>
    <v-card class="sheet">
      <o-main-progress v-if="!loadedAll"/>
      <Scoring 
        v-else
        @terminado="terminado()"
        @error="error"
        :incrustado="true"
      />
    </v-card>
  </v-container>
</template>

<script>
import Scoring from '@/components/reservas/scoring/Scoring'
import { mapGetters, mapActions } from 'vuex'
import {incrustado} from '@/mixins/incrustado'

export default {
  mixins: [incrustado],
  props: [ 'simplificada', 'parametrosSimplificada'],
  components: {
    Scoring
  },
  data () {
    return {
      loadedAll: false
    }
  },
  computed: {
    ...mapGetters({
      inmueble: 'promociones/inmuebles/getActual',
      reserva: 'reservas/_id/getActual',
      promocion: 'promociones/getActual',
      scoring: 'scoring/get',
      codigoPromocion: 'incrustado/codigoPromocion',
      codigoActivo: 'incrustado/codigoActivo'
    }),
    objetoParaApi () {
      let retorno = {...this.parametrosSimplificada.objetoParaApi}
      retorno.compradoresScoring=  this.scoring.compradores !== undefined ? this.scoring.compradores : null
      return retorno
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadInmueble: 'promociones/inmuebles/load',
      loginCRM: 'login/loginCRMSimplificada',
      crearReserva: 'reservas/_id/crear',
      loadReserva: 'reservas/_id/load',
      loadActual: 'modulosOrdenes/loadActual'
    }),
    async initialize () {
      try {
        await Promise.all([
          this.loadInmueble({
            codigoPromocion: this.codigoPromocion,
            codigoActivo: this.codigoActivo,
            alquiler: true
          }),
          this.loadActual({alquiler:true, codigoPromocion: this.codigoPromocion, simplificada: this.simplificada})
        ])
        // comprobación existen los datos
        if (this.inmueble == null ||
          this.inmueble.tarifaAlquiler == null ||
          this.promocion == null
        ) {
          this.$router.push({name: 'incrustado.mensajeError'})
          return false
        }
        return true
      } catch (error) {
        if (!error.code || (error.code !== 1 && error.code !== 11 && error.code !== 10)) {
          this.addAlert({texto: error.message, color: 'error'})
          this.$router.push({name: 'incrustado.mensajeError'})
        } else if (error.code === 11) {
          this.$router.push({name: 'incrustado.mensajeReservado', params: {reservaUsuario: true}})
        } else if (error.code === 10) {
          this.$router.push({name: 'incrustado.mensajeReservado', params: {reservaUsuario: false}})
        }
        return false
      }
    },
    async terminado () {
      if (!this.simplificada) {
        this.$router.push({name: 'incrustado.registro'})
      } else {
        await this.loginCRM({
          id_bd_prinex: this.parametrosSimplificada.idubapi,
          cod_cli: this.parametrosSimplificada.cod_cli,
          token: this.parametrosSimplificada.token, 
          simplificada: true,
          email_comercial: this.parametrosSimplificada.emailComercial
        })
        await this.crearReserva(this.objetoParaApi)
        await this.loadReserva(this.reserva.id)
        this.$router.push({name: 'reservas.id.simplificada', params: { id: this.reserva.id }})
      }
      
    },
    error () {
      this.$router.push({name: 'incrustado.mensajeError'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/incrustado/scoring.vue